import { useCallback } from 'react';

import { useConditionState } from './useConditionState';
import { useCurrentConditionIndex } from './useCurrentConditionIndex';
import { useCriteriaRequirementsState } from '../criteria';
import { useCurrentRequirementIndex, useRequirementConditionsState } from '../requirement';
import { useQueryStateContext } from '../../contexts';
import { ClientDataType } from '../../types';

export const useRemoveCondition = () => {
  const { setConditions, conditions } = useRequirementConditionsState();
  const { condition } = useConditionState();
  const { setRequirements } = useCriteriaRequirementsState();
  const { resetQueryId } = useQueryStateContext();
  const index = useCurrentConditionIndex();
  const requirementIndex = useCurrentRequirementIndex();

  const isUserRequirement = condition.dataType === ClientDataType.User;
  const isLastCondition = conditions.length === 1;

  return useCallback(() => {
    // Remove requirement as well if removing last condition from a user requirement
    if (isLastCondition && isUserRequirement && index === 0) {
      setRequirements((requirements) => requirements.filter((_, i) => i !== requirementIndex));
    } else {
      setConditions((conditions) => conditions.filter((_, i) => i !== index));
    }
    resetQueryId();
  }, [setConditions, setRequirements, index, requirementIndex, isUserRequirement, isLastCondition]);
};
